import { render, staticRenderFns } from "./main-features.vue?vue&type=template&id=435d0c10&scoped=true&"
import script from "./main-features.vue?vue&type=script&lang=js&"
export * from "./main-features.vue?vue&type=script&lang=js&"
import style0 from "./main-features.vue?vue&type=style&index=0&id=435d0c10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435d0c10",
  null
  
)

export default component.exports